import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const BLogCardHome = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_BLOGS;

            const cachedBlogs = localStorage.getItem("blogsHome");
            const cacheTimestamp = localStorage.getItem("blogsHomeTimestamp");
            const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

            if (cachedBlogs && cacheTimestamp && (Date.now() - cacheTimestamp < cacheExpiryTime)) {
                setBlogs(JSON.parse(cachedBlogs));
            } else {
                try {
                    const response = await axios.get(`${apiBaseUrl}${Url}`);
                    setBlogs(response.data);
                    localStorage.setItem("blogsHome", JSON.stringify(response.data));
                    localStorage.setItem("blogsHomeTimestamp", Date.now());
                } catch (error) {
                    console.error('Failed to fetch blogs:', error);
                }
            }
        };

        fetchBlogs();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <section className="blog-area pt-80 pb-80" style={{ backgroundColor: '#f8fafc' }}>
            <div className="container px-1">
                {/* Modern Section Header (Matched with previous sections) */}
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-8 text-center">
                        <span className="text-primary fw-bold text-uppercase" style={{ letterSpacing: '2px', fontSize: '0.9rem' }}>
                            Updates & Insights
                        </span>
                        <h2 className="display-6 fw-bold text-dark mt-2 mb-3">Our News & Articles</h2>
                        <div className="bg-primary mx-auto" style={{ width: '60px', height: '3px', borderRadius: '2px' }}></div>
                    </div>
                </div>

                {/* Blog Slider */}
                <div className="carousel-container">
                    <div className="blog-slider">
                        <Slider {...settings}>
                            {blogs.map((blog, index) => (
                                <div className="px-2 pb-4" key={index}>
                                    <article
                                        className="card h-100 border-0 shadow-sm overflow-hidden bg-white"
                                        style={{
                                            borderRadius: '16px',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-8px)';
                                            e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.1)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 0.125rem 0.25rem rgba(0,0,0,0.075)';
                                        }}
                                    >
                                        <div style={{ overflow: 'hidden' }}>
                                            <img
                                                src={`${backendBaseUrl}${blog?.image}`}
                                                alt="thumb"
                                                className="w-100 h-100"
                                                style={{ objectFit: 'cover', transition: 'transform 0.5s ease' }}
                                            />
                                        </div>
                                        <div className="card-body p-4 d-flex flex-column justify-content-between">
                                            <div>
                                                <h5 className="fw-bold text-dark mb-3" style={{ fontSize: '18px', lineHeight: '1.4' }}>
                                                    {blog?.title}
                                                </h5>
                                                <p className="text-muted small mb-4" style={{ lineHeight: '1.6' }}>
                                                    {blog?.short_description?.length > 110
                                                        ? `${blog.short_description.slice(0, 110)}...`
                                                        : blog?.short_description}
                                                </p>
                                            </div>
                                            <div>
                                                <Link
                                                    className="text-primary text-decoration-none fw-bold small d-inline-flex align-items-center"
                                                    to={`/blog/details/${blog?.slug}`}
                                                >
                                                    Read More <i className="fa fa-arrow-right ms-2"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BLogCardHome;